import { OndemandRide, RidangoReduxAction } from '@ridango/core';

import momenttz from 'moment-timezone';

import { RideHistoryActions } from './ride-history.actions';

export const RIDE_HISTORY_STATE_KEY = 'rideHistory';

export interface RideHistoryState {
    rides: OndemandRide[];
    loading: boolean;
    error: any;
    startDate: Date;
    endDate: Date;
    minStartDate: Date;
    minEndDate: Date;
    maxStartDate: Date;
    maxEndDate: Date;
    diff: number;
}

export const RIDE_HISTORY_INITIAL_STATE: RideHistoryState = {
    rides: [],
    loading: false,
    error: {},
    startDate: momenttz.tz('Europe/Tallinn').subtract(29, 'days').toDate(),
    endDate: momenttz.tz('Europe/Tallinn').toDate(),
    minStartDate: momenttz.tz('Europe/Tallinn').subtract(360, 'days').toDate(),
    minEndDate: momenttz.tz('Europe/Tallinn').subtract(360, 'days').toDate(),
    maxStartDate: momenttz.tz('Europe/Tallinn').toDate(),
    maxEndDate: momenttz.tz('Europe/Tallinn').toDate(),
    diff: 29,
};

export function rideHistoryReducer(
    state: RideHistoryState = RIDE_HISTORY_INITIAL_STATE,
    action: RidangoReduxAction
): RideHistoryState {
    switch (action.type) {
        case RideHistoryActions.FETCH_RIDE_HISTORY:
            return {
                ...state,
                loading: true,
            };
        case RideHistoryActions.FETCH_RIDE_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                rides: action.payload,
            };
        case RideHistoryActions.FETCH_RIDE_HISTORY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case RideHistoryActions.SET_START_DATE:
            return {
                ...state,
                startDate: action.payload,
            };
        case RideHistoryActions.SET_END_DATE:
            return {
                ...state,
                endDate: action.payload,
            };
    }

    return state;
}

export interface RideHistoryPartialStoreState {
    [RIDE_HISTORY_STATE_KEY]: RideHistoryState;
}
